/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_CtaInputs */

const en_mk_publish_cta = /** @type {(inputs: Mk_Publish_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the full workflow`)
};

const id_mk_publish_cta = /** @type {(inputs: Mk_Publish_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat alur lengkap`)
};

/**
* | output |
* | --- |
* | "Explore the full workflow" |
*
* @param {Mk_Publish_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_cta = /** @type {((inputs?: Mk_Publish_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_cta(inputs)
	return en_mk_publish_cta(inputs)
});